import React, { Component } from 'react';
import gripList from '../../data/grip';
import GripBanner from './GripBanner';
import Carousel from 'react-bootstrap/Carousel';
import { isMobile } from 'react-device-detect';
import ReactGA from 'react-ga';
import Mail from '@material-ui/icons/Mail';
import Fab from '@material-ui/core/Fab';
import { Trans } from 'react-i18next';
import Paper from '@material-ui/core/Paper';
import { API_BASE_URL } from '../../constatns';
import Alert from 'react-s-alert';

class IcastPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      name: '',
      title: 'icast2020',
      contents: '',
      mailSent: false,
      error: null,
      gripData: gripList,
      isShow: false,
    };
    // this.setState({isShow: false});
    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.trackScrolling = this.trackScrolling.bind(this);
  }

  componentWillMount() {
    window.addEventListener('scroll', this.trackScrolling);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.trackScrolling);
  }

  trackScrolling = () => {
    const { innerHeight } = window;
    const { scrollHeight } = document.body;
    const scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    if (scrollHeight - innerHeight - scrollTop < 100) {
      console.log('Almost Bottom Of This Browser');
      this.setState({ isShow: true });
    }
  };

  handleFormSubmit = (e) => {
    e.preventDefault();

    fetch(API_BASE_URL + '/bbs/inquiry/', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(this.state),
    })
      .then((e) => e.json())
      .then((e) => {
        this.setState({
          email: '',
        });

        ReactGA.event({
          category: 'ICAST',
          action: 'Registered',
        });

        if (isMobile) {
          alert("You're successfully registered!");
        } else {
          Alert.success("You're successfully registered!");
        }

        this.setState({ isShow: false });
      })
      .catch((error) => this.setState({ error: error.message }));
  };

  toggleDrawer() {
    this.setState({ isShow: !this.state.isShow });
  }

  render() {
    ReactGA.pageview(window.location.pathname + window.location.search);

    // const serviceItems = this.state.gripData.serviceList.map((item) => {
    // 	return (
    // 		<div key={item.id} className="col-lg-6 col-sm-6 col-md-6">
    // 			{/*<FeatureItem key={item.id} heading={item.heading} info={item.info} imgUrl={item.imgUrl} />*/}
    // 			<div className="single-features">
    // 				<div className="features-icon d-flex align-items-center justify-content-center">
    // 					<img
    // 						src={item.imgUrl}
    // 						alt=""
    // 						className="animate"
    // 						data-animate="rubberBand"
    // 						data-duration="1s"
    // 						data-delay="0.1s"
    // 					/>
    // 				</div>
    // 				<div className="features-content">
    // 					<h4>{item.heading}</h4>
    // 					<div className="animate" data-animate="fadeIn" data-duration="1s" data-delay="0.2s">
    // 						<p>{item.info}</p>
    // 					</div>
    // 				</div>
    // 			</div>
    // 		</div>
    // 	);
    // });

    return (
      <main className={'grip-page'}>
        <GripBanner />

        {/*<Subscribe/>*/}

        <section className="service-area relative mt-50 mb-50">
          <div className="container">
            <div className="row align-items-center">
              {isMobile ? (
                <div className="col-lg-5">
                  <img className="img-fluid " src={require('../../assets/img/halasz_grip.jpg')} alt="" />
                  <img className="img-fluid " src={require('../../assets/img/grip.gif')} alt="" />
                </div>
              ) : (
                <div className="col-lg-5">
                  <img className="img-fluid " src={require('../../assets/img/img_grip.png')} alt="" />
                </div>
              )}

              <div className="col-lg-7 mt-10">
                <h4>HALASZ FishingGrip</h4>
                <div className={'mt-10'}>
                  Nowadays, catch & release culture is spreading, and the act of saving fish by letting them go is good, but if the method
                  is not correct, then it is not good at all.
                </div>
                <img
                  className={'mb-10 mt-10'}
                  width={'100%'}
                  src="https://cdn.wadiz.kr/ft/images/green001/2019/1023/20191023121116075_109.jpg/wadiz/format/jpg/quality/80/optimize"
                  alt=""
                />
                <p>
                  There is also a way to put your hands into the water and catch fish after dropping the hand temperature, but for fish that
                  are temperate animals, even if the hand temperature is dropped, it is still much higher than the water the fish live in,
                  causing serious burns to the fish, which is fatal.
                </p>
                <h4>But...</h4>
                <p>
                  By using fishing grips, fish are protected from burns and wounds that can occur from human body temperature and strength,
                  and humans are protected from fish's pointed fins or sharp teeth. In addition, catching a fish's lips in the water with
                  fishing grips will help minimize the time it takes to take out the hook or out of the water.
                </p>
              </div>
            </div>
            <div className="row align-items-center mt-20">
              <div className="row" width={'100%'}>
                <div className="col-lg-6 col-sm-6 col-md-6">
                  <div className="single-features">
                    <div className="features-content">
                      <h4>
                        <span className="blue">1</span>
                        <Trans i18nKey="feature.realtime.title" />
                      </h4>
                      <div className="animate" data-animate="fadeIn" data-duration="1s" data-delay="0.2s">
                        <span>
                          <Trans i18nKey="feature.realtime.desc" />
                        </span>
                        <img src="https://cdn.wadiz.kr/ft/images/green002/2019/1021/20191021114102747_95.gif" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-md-6">
                  <div className="single-features">
                    <div className="features-content">
                      <h4>
                        <span className="blue">2</span>
                        <Trans i18nKey="feature.ble.title" />
                      </h4>
                      <div className="animate" data-animate="fadeIn" data-duration="1s" data-delay="0.2s">
                        <span>
                          <Trans i18nKey="feature.ble.desc" />
                        </span>
                        <img src="https://cdn.wadiz.kr/ft/images/green002/2019/1023/20191023113658995_109.gif" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row" width={'100%'}>
                <div className="col-lg-6 col-sm-6 col-md-6">
                  <div className="single-features">
                    <div className="features-content">
                      <h4>
                        <span className="blue">3</span>
                        <Trans i18nKey="feature.measure.title" />
                      </h4>
                      <div className="animate" data-animate="fadeIn" data-duration="1s" data-delay="0.2s">
                        <span>
                          <Trans i18nKey="feature.measure.desc" />
                        </span>
                        <img src="https://cdn.wadiz.kr/ft/images/green001/2019/1025/20191025190503687_34.gif" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-md-6">
                  <div className="single-features">
                    <div className="features-content">
                      <h4>
                        <span className="blue">4</span>
                        <Trans i18nKey="feature.realtime.title" />
                      </h4>
                      <div className="animate" data-animate="fadeIn" data-duration="1s" data-delay="0.2s">
                        <span>
                          <Trans i18nKey="feature.realtime.title" />
                        </span>
                        <img src="https://cdn.wadiz.kr/ft/images/green001/2019/1017/20191017110619207_89.gif" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row" width={'100%'}>
                <div className="col-lg-6 col-sm-6 col-md-6">
                  <div className="single-features">
                    <div className="features-content">
                      <h4>
                        <span className="blue">5</span>
                        <Trans i18nKey="feature.photo.title" />
                      </h4>
                      <div className="animate" data-animate="fadeIn" data-duration="1s" data-delay="0.2s">
                        <span>
                          <Trans i18nKey="feature.photo.desc" />
                        </span>
                        <img src="https://cdn.wadiz.kr/ft/images/green001/2019/1016/20191016152811217_50.gif" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-md-6">
                  <div className="single-features">
                    <div className="features-content">
                      <h4>
                        <span className="blue">6</span>
                        <Trans i18nKey="feature.strong.title" />
                      </h4>
                      <div className="animate" data-animate="fadeIn" data-duration="1s" data-delay="0.2s">
                        <span>
                          <Trans i18nKey="feature.strong.desc" />
                        </span>
                        <img src="https://cdn.wadiz.kr/ft/images/green001/2019/1016/20191016134103275_69.gif" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/*<div className="row">{serviceItems}</div>*/}
            </div>
            {!isMobile ? (
              <div className="row align-items-center mb-20 col-lg-10 offset-lg-4">
                <img className="w-50" src={require('../../assets/img/grip.gif')} alt="" />
              </div>
            ) : (
              ''
            )}

            <div className="align-items-center mb-20 col-lg-8 offset-lg-4">
              <Carousel className="col-lg-8">
                <Carousel.Item>
                  <img className="d-block w-100" src="https://halasz-media.s3.ap-northeast-2.amazonaws.com/etc/grip_use_1.jpg" />
                </Carousel.Item>
                <Carousel.Item>
                  <img className="d-block w-100" src="https://halasz-media.s3.ap-northeast-2.amazonaws.com/etc/grip_use_2.jpg" />
                </Carousel.Item>
                <Carousel.Item>
                  <img className="d-block w-100" src="https://halasz-media.s3.ap-northeast-2.amazonaws.com/etc/grip_use_3.jpg" />
                </Carousel.Item>
                <Carousel.Item>
                  <img className="d-block w-100" src="https://halasz-media.s3.ap-northeast-2.amazonaws.com/etc/grip_use_5.jpg" />
                </Carousel.Item>
                <Carousel.Item>
                  <img className="d-block w-100" src="https://halasz-media.s3.ap-northeast-2.amazonaws.com/etc/grip_use_6.jpg" />
                </Carousel.Item>
              </Carousel>
            </div>
          </div>
        </section>

        <div className={this.state.isShow ? 'subscribeOpen' : 'subscribeClose'}>
          <Fab className="fabSubscribe animate" variant="extended" onClick={this.toggleDrawer}>
            <Mail /> SUBSCRIBE
          </Fab>

          <div className="subscribe">
            <Paper className="row align-items-center">
              <div className="col-lg-12">
                <div className="subscribeWrap">
                  <div className="section-title">
                    <h2>
                      <b>
                        <Trans i18nKey="subscribe.title" />
                      </b>
                    </h2>
                  </div>
                  <div className="subscribe-form relative mb-10">
                    <div id="mc_embed_signup">
                      <form target="_blank" method="get" className="newsletter relative">
                        <input
                          name="EMAIL"
                          placeholder="Your email address"
                          className="common-input"
                          required=""
                          type="email"
                          value={this.state.email}
                          onChange={(e) => {
                            this.setState({
                              email: e.target.value,
                            });
                          }}
                        />
                        <button className="primary-btn" onClick={(e) => this.handleFormSubmit(e)}>
                          Send
                          <span className="lnr lnr-arrow-right" />
                        </button>
                        <div className="info" />
                      </form>
                    </div>
                  </div>
                  <span className="subDesc">
                    <Trans i18nKey="subscribe.desc" />
                  </span>
                </div>
              </div>
            </Paper>
          </div>
        </div>
      </main>
    );
  }
}

export default IcastPage;
